<template>
     <section class="section-one-full-blocks">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="text-wrap center-align">
                            <div class="section-right mb4">
                                <p class="mb4"><hr class="hr-purple"><span>Have Your Say</span></p>
                                <h1 class="mb2"><b>Need more information?</b></h1>
                                <p>View our frequently asked questions or view the consultation brochure for further details about Phase 2.</p>
                                <a href="/site/faqPage" class="cta cta-purple">Visit FAQ’s</a> <a href="https://firebasestorage.googleapis.com/v0/b/pinpoint-belfastrapidtransit.appspot.com/o/BRT2%20brochure_Accessible_220721.pdf?alt=media&token=b7200784-bb57-4ee4-b743-03fb5d6f27b1" class="cta cta-purple" target="_blank">View our brochure</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
    }
  },
  mounted () {
  
    
  },
  methods: {
   
  }
}
</script>
<style lang="scss">
.section-one-full-blocks{
   // position: relative;
    padding: 4rem 0;
    margin: 0 auto;
    background:#FCCF49 url('../../assets/images/Belfast/PathMaskYellow.png') no-repeat;
    //content: "";
    //       display: block;
    //       width: 100%;
    //       height: 100%;
    //       background-position: 50%;
    //       // background: url('https://via.placeholder.com/1024x768') no-repeat;
    //       background-position: 100%;
    //       position: absolute;
    //       top: 0;
    //       left: 0;
    //       bottom: 0;
    //       background:#FCCF49 url('../../assets/images/Belfast/PathMaskYellow.png') no-repeat;
      
   
    
}


</style>
